'use client';
import {
	Box,
	Stack,
	Heading,
	Text,
	VStack,
	useColorModeValue,
	Image,
	SimpleGrid,
	Alert,
	Spinner,
	Tabs,
	TabList,
	TabPanels,
	Tab,
	TabPanel,
	useBreakpointValue,
	Flex,
	Button,
	Link,
	Tooltip,
} from '@chakra-ui/react';
import PriceWrapper from '../priceWrapper/PriceWrapper';
import { useEffect, useState } from 'react';
import api from '../../utils/axios';
import { useAccount, useBalance } from 'wagmi';
import CustomConnectButton from '../CustomConnectButton';
import { motion } from 'framer-motion';
import { ethers } from 'ethers';
import { useLocation, useNavigate } from 'react-router-dom';
import MintButton from './MintButton';
import BurnButton from './BurnButton';
import noKeyImage from '../../../src/assets/images/png/no-key.png';
import keyImage from '../../../src/assets/images/png/key-image.png';
import { ReactComponent as EtherscanSvg } from '../../assets/images/svg/etherscan-logo-circle.svg';
import './styles.css';
import VideoModal from '../VideoModal';
import { InfoOutlineIcon } from '@chakra-ui/icons';


const MotionHeading = motion(Heading);

function MintKey({ savedEventCount, currentTier, tierData, imageURI, txError }) {
	const currentTierColor = useColorModeValue('green.300', 'green.700');
	const nonCurrentTierColor = useColorModeValue('red.300', 'red.700');
	const textColor = useColorModeValue('gray.900', 'gray.300');
	const buttonVariant = useColorModeValue('outline', 'solid');

	// const isAllMinted = (currentTier === '3' && tierData[2].minted === tierData[2].supply);
	const isAllMinted = (currentTier === '3');
	const { address } = useAccount();
	const [userKeys, setUserKeys] = useState([]);
	const [imageLoading, setImageLoading] = useState({});
	const { isConnected } = useAccount();
	const isMobile = useBreakpointValue({ base: true, md: false });
	const { data: balance, isError, isLoading } = useBalance({
		address,
	});

	const location = useLocation();
	const navigate = useNavigate();
	const currentTab = location.pathname; // Получаем текущий путь

	const getMintKeys = async () => {
		const response = await api.get(`/user/keys?address=${address}`);
		setUserKeys(response.data);
		// Initialize loading states for images
		const initialLoadingState = response.data.reduce((acc, key) => {
			acc[key.token_id] = true;
			return acc;
		}, {});
		setImageLoading(initialLoadingState);
	};

	useEffect(() => {

		if (address) getMintKeys();
	}, [address]);

	const isEnoughtBalance = tierData && balance && (parseFloat(ethers.formatEther(balance.value.toString())) >= parseFloat(tierData[0].price));

	const handleTabChange = (index) => {
		const path = index === 0 ? '/mint-key' : '/my-keys';
		navigate(path);
	};

	return (
		<>
			<VStack spacing={2} textAlign="center">
				<MotionHeading
					fontSize="clamp(1.5em, 2.8vw, 2.4em)"
					initial={{ opacity: 0, y: 20 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 1 }}
					textAlign={"center"}
					m={!isMobile ? 6 : 1}
				>
					Mint Access Key
				</MotionHeading>

				<Text fontSize="lg" color={'gray.500'}>
					Mint now to unlock multiple rating requests, track your progress with a daily marks history chart, save your data to CSV, and enjoy all future features!
				</Text>
			</VStack>
			{txError && <Alert>{txError}</Alert>}

			<Tabs
				variant='soft-rounded'
				colorScheme='orange'
				pt={4}
				index={currentTab === '/mint-key' ? 0 : 1} // Устанавливаем индекс вкладки в зависимости от текущего URL
				onChange={handleTabChange} // Обработчик изменения вкладки
			>
				<TabList justifyContent={"center"} alignContent={"center"} alignItems={"center"}>
					<Tab>Mint</Tab>
					<Tab isDisabled={!isConnected}>My Keys</Tab>
				</TabList>
				<TabPanels>
					<TabPanel>
						<Stack
							direction={{ base: 'column', md: 'row' }}
							textAlign="center"
							justify="center"
							align="center"
							spacing={{ base: 4, lg: 10 }}
							py={4}
							overflowX="auto"
						>
							{tierData.map((tier, index) => {
								return (
									<PriceWrapper key={index}>
										<Box position="relative">
											{
												index === 0 &&
												<Box
													position="absolute"
													top="-16px"
													left="50%"
													transform="translate(-50%)"
												>
													<Text
														textTransform="uppercase"
														// bg={!isAllMinted ? currentTierColor : nonCurrentTierColor}
														bg={index === 0 ? currentTierColor : nonCurrentTierColor}
														px={3}
														py={1}
														color={"gray.900"}
														// color={textColor}
														fontSize="sm"
														fontWeight="600"
														rounded="xl"
													>
														{index === 0 ? 'Current Tier' : 'Mint finished'}
													</Text>
												</Box>
											}
											<Box pt={4} px={12}>
												<Text fontWeight="500" fontSize="2xl" mt={2}>
													{tier.name}
												</Text>
												<Flex borderRadius={15} justifyContent={"center"} mb={6} pt={5}>
													{tier.discount !== '0' &&
														<Box
															position="absolute"
															top={2}
															opacity={0.95}
															right={4}
															bg="red.500"
															color="white"
															width="50px"  // Задаем ширину
															height="50px" // Задаем высоту
															display="flex"
															alignItems="center"
															justifyContent="center"
															borderRadius="full"  // Делаем блок круглым
															fontWeight="bold"
															fontSize="sm"
														// boxShadow="md"
														>
															-{tier.discount}%
														</Box>
													}
													{/* {!imageURI && <Spinner />} */}
													<Image
														src={keyImage}
														borderRadius={'xl'}
														maxW="200px"
														_hover={{ transform: 'scale(1.05)' }}
													// onLoad={() => handleImageLoad(index)}
													// style={{ display: imageLoading[index] ? 'none' : 'block' }}
													/>
												</Flex>

												<Text fontSize="3xl" fontWeight="700" mt={2}>
													{tier.price} <span>ETH</span>
													{
														<Tooltip
															label={
																<Flex justifyContent={"center"} bg='white'>
																	<Flex bg='white' color='black' fontSize={"xs"} justifyContent={"center"} flexDirection={"column"} alignItems={"flex-start"}>
																		<Box>+1 Transaction</Box>
																		<Box>+1 Contract Interaction</Box>
																		<Box>+1 NFT</Box>
																		<Box>+1 Karma</Box>
																		<Box>+ Unlock all features</Box>
																	</Flex>
																</Flex>
															}
															bg="white"
															color="black"
															fontSize="md"
															// placement='top-start'
															placement='right'
															p={4}
														>
															<InfoOutlineIcon fontSize={"sm"} ml={1} />
														</Tooltip>
													}
												</Text>

											</Box>
											<VStack pb={8} borderBottomRadius={'xl'}>
												<Flex flexFlow={"row"} gap={2} justifyContent={"center"} pt={1} alignItems={"center"}>
													<Text pl={"10px"} pt="2px">Minted: {tier.minted}/{tier.supply}
														{index === 0 && parseInt(savedEventCount) !== parseInt(tier.minted) ? `(+${tier.minted - savedEventCount} Pending)` : ''}</Text>
													<Link href={"https://scrollscan.com/address/0x433d95ae55f284d3de52ad8ab2c09b80ebb0c9a6"} isExternal>
														<EtherscanSvg width={18} height={18} />
													</Link>
												</Flex>

												{isConnected ? <MintButton
													price={tier.price}
													isCurrent={true}
													isDisabled={!isEnoughtBalance || index !== 0}
													variant={'solid'}
													colorScheme={'orange'}
													text={isEnoughtBalance ? 'Mint Key' : 'You don\'t have enough ETH'}
													getMintKeys={getMintKeys}
												/> :
													<Box w={"80%"} pt={1}>
														<CustomConnectButton width={"100%"} colorScheme={'orange'} bg={"#DD6B20"} _hover={{ background: "#C05621" }} />
													</Box>
												}
											</VStack>
										</Box>
									</PriceWrapper>
								);
							})}
						</Stack>
						<Flex justifyContent={"center"}>
							<VideoModal videoUrl="https://scrollstat.xyz/assets/videos/mint.mp4" />
						</Flex>
					</TabPanel>
					<TabPanel>
						{userKeys.length > 0 ? (
							<VStack direction={{ base: 'column', md: 'row' }}
								textAlign="center"
								justify="center"
								align="center"
								spacing={{ base: 4, lg: 10 }}
								py={4}
								overflowX="auto">
								<SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing={10}  >
									{userKeys.map((key) => (
										<PriceWrapper key={key.token_id}>
											<Box key={key.token_id} overflow="hidden" >
												<Box pt={4} px={12}>
													<Text fontWeight="500" fontSize="2xl" mt={2}>
														Tier {key.tier}
													</Text>
													{!imageURI && <Spinner />}
													<Box borderRadius={15} mt={2}>
														<Image
															src={imageURI}
															borderRadius={'xl'}
															alt={`Token ${key.token_id}`}
														/>
													</Box>
												</Box>
												<Text mt={4} mb={2}>Key #{key.token_id}</Text>
												<BurnButton tokenId={key.token_id} getMintKeys={getMintKeys} />
											</Box>
										</PriceWrapper>
									))}
								</SimpleGrid>
							</VStack>
						) : (
							<Flex justifyContent={"center"} flexFlow={"column"} alignItems={"center"} pt={4}>
								<Image
									src={noKeyImage}
									maxW="250px"
									className="shake-animation" // Примените CSS класс
								/>
								<Text mt={8} textAlign={"center"}>You don't have any keys yet.</Text>
								<Button
									mt={4}
									onClick={() => {
										navigate('/mint-key')
									}}
									colorScheme={'orange'} bg={"#DD6B20"} _hover={{ background: "#C05621" }}
								>
									Mint key
								</Button>
							</Flex>
						)}
					</TabPanel>
				</TabPanels>
			</Tabs>
		</>
	);
}

export default MintKey;
